<template>
  <div class="clearfix ">
    <div class="d-flex justify-content-center">
      <b-form-group id="attendance_flexibility-group" label-for="attendance_flexibility">
        <b-form-checkbox id="attendance_flexibility" @change="changeFlexibilityStatus" v-model="attendance_flexibility" name="attendance_flexibility" :value="1" :unchecked-value="0">
          Enable Attendance Flexibility
        </b-form-checkbox>
      </b-form-group>
    </div>
    <div v-if="attendance_flexibility == 1" class="row">
        <div class="col-sm-12 row mt-4 ">
        <div class="col-sm-6">
          <b-form-group id="office_start_time-group" label="Office Start Time" label-for="office_start_time">
            <template>
              <b-form-timepicker id="office_start_time" name="office_start_time" v-model="office_start_time" now-button reset-button locale="en" :disabled="disabled_by_acl"></b-form-timepicker>
            </template>
          </b-form-group>

        </div>

        <div class="col-sm-6">
          <b-form-group id="office_end_time-group" label="Office End Time" label-for="office_end_time" >
            <template>
              <b-form-timepicker id="office_end_time" name="office_end_time" v-model="office_end_time" now-button reset-button locale="en" :disabled="disabled_by_acl"></b-form-timepicker>
            </template>
          </b-form-group>

        </div>
      </div>

      <div class="mt-3 col-sm-6" v-if= "disabled_by_acl == false">
        <b-button :disabled="loading" variant="success" @click="saveSettings()">Update</b-button>
      </div>
    </div>

  </div>
</template>

<script>
export default{
  data(){
    return {
      loading: false,
      company_id : 0 ,
      office_start_time : null,
      office_end_time : null,
      disabled_by_acl:false,
      acl:this.$acl,
      attendance_flexibility:0,
    }
  },
  methods:{
    checkSuperUser : function()
    {
      axios.get(this.$api_url+'/user-type-level').then(function(response){
        if((response.data.user_type == '1') && (response.data.user_level == '1'))
          this.supper_user = true;

      }.bind(this));
    },

    getCompanyMobilitySettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/attendance-mobility/settings').then(response => {
        this.office_start_time = response.data.office_start_time
        this.office_end_time = response.data.office_end_time
      }).catch(err => this.serverError(err));

    },
    saveSettings:function()
    {
      this.loading = true;
      let currentObj = this;
      let formData = new FormData();

      formData.append('office_start_time', this.office_start_time);
      formData.append('office_end_time', this.office_end_time);

      axios.post(this.$api_url+'/attendance-mobility/settings', formData,)
          .then(function (response)
          {
 
            this.$bvToast.toast('Saved!', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            this.loading = false;

          }.bind(this))
          .catch(error=>
          {
            this.loading = false;
            currentObj.serverError(error);
          });
    },

      getAttendanceFlexibilityStatus(){
        axios.get(this.$api_url + '/attendance-mobility/flexibility/status').then(response => {
          this.attendance_flexibility = response.data;
        });
      },

      changeFlexibilityStatus(){
        axios.post(this.$api_url + '/attendance-mobility/flexibility/status').then(response => {
          this.$bvToast.toast(response.data.message,{
            variant: 'success',
            title: 'Success',
            solid: true,
          });
        });
      },
  },
  created: function(){
    this.getCompanyMobilitySettings();
    this.checkSuperUser();
    this.getAttendanceFlexibilityStatus();

    if(this.acl['leave-attendances'] != 2)
    {
      this.disabled_by_acl = true;
    }
  },
}
</script>
<style >
.trz_leave_settings .custom-select{width: auto !important;}
.trz-wizard-sidebar-settings .nav li.nav-item{margin-bottom:10px;}
.trz_list li{margin-top:5px;}
.trz-leave-settings-wrapper .card-header.trz-wizard-sidebar-settings {
  border-bottom-color: unset !important;
}


.trz-leave-settings-wrapper .card-header.trz-wizard-sidebar-settings {
  padding: 0 0.6rem !important;
  margin-bottom: 0;
  background-color: unset;
  border-bottom: unset;
}
.trz-leave-settings-wrapper {
  padding: 1.25rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
}

.trz-leave-settings-wrapper .card-body {
  padding-bottom: 25px;
}
</style>

